import 'jquery';
import 'jquery-ui/ui/version';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/safe-active-element';
import 'jquery-ui/ui/data';
import 'jquery-ui/ui/tabbable';
import 'jquery-ui/ui/focusable';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/accordion';
import 'jquery-ui/ui/widgets/button';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery.maskedinput';
import 'jquery.maskedinput/src/jquery.maskedinput.js';
import 'jtable';
import browserUpdate from 'browser-update';
import './nav.js';
import './dashboard.js';
import './download.js';
import './recordrequest.js';
import './status.js';
import './change_password.js';
import './signup.js';

browserUpdate({
  required: {
    e: -3,
    i: 11,
    f: -3,
    o: -3,
    s: -3,
    c: -3
  },
  reminder: 24,
  reminderClosed: 150,
  insecure: true,
  unsupported: true,
  mobile: false
});